export enum SheetStatus {
	PENDIENTE = 1,
	APROBADA = 2,
	ENVIADA = 3,
	OBSERVADA = 4,
	RECTIFICADA = 5,
	CONSOLIDADA = 6,
	NOPRESENTADA = 7
}
